/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Fragment } from 'react';

import { ILabelColor, TableLabelCellCircleStyled, TableLabelCellStyled } from './styled/LabelCellStyled';
import { ILabel } from './types';

interface ITableCellLabel {
    labels: ILabel[];
}

const LabelCell = ({ labels }: ITableCellLabel) => {
    return (
        <Fragment>
            {labels.map((label: ILabel) => (
                <TableLabelCellStyled key={label.id}>
                    <TableLabelCellCircleStyled color={('color' + label.color) as ILabelColor} />
                    <div className="table__tooltip-text">{label.name}</div>
                </TableLabelCellStyled>
            ))}
        </Fragment>
    );
};

export default LabelCell;
